<template>
  <div class="c-strategy">
    {{ strategy }}
  </div>
</template>

<script>
import { StrategyService } from '@/utils/optionChainServices/strategyService';

export default {
  name: 'c-strategy',
  props: {
    legs: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      strategy: this.$t('white-label.widgets.optionChain.strategies.custom')
    };
  },
  watch: {
    legs: {
      handler: 'handleLegs',
      deep: true
      //immediate: true
    }
  },
  methods: {
    handleLegs() {
      this.strategy =
        this.legs.first || this.legs.second
          ? this.getFormattedStrategy(StrategyService.detectOptionStrategy(this.legs.first, this.legs.second))
          : this.$t('white-label.widgets.optionChain.strategies.custom');
    },
    getFormattedStrategy(strategy) {
      const formattedStrategy = strategy
        .toLowerCase()
        .split('_')
        .map(s => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ');
      this.$emit('updateStrategy', formattedStrategy);
      return formattedStrategy;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/styles/components/custom/c-strategy';
</style>
